import { Radio } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'
import type { PayMethod } from '@/api/topup'

export function getMethodLabel(type: string, t: TFunction) {
  const labels: Record<string, string> = {
    alipay: t('tt.topup.methodAlipay'),
    wxpay: t('tt.topup.methodWxpay'),
    stripe: t('tt.topup.methodStripe'),
    creem: t('tt.topup.methodCreem'),
    waffo: t('tt.topup.methodWaffo'),
    custom1: t('tt.topup.methodCustom'),
  }
  return labels[type] || type
}

interface PaymentMethodPickerProps {
  methods: PayMethod[]
  value: string
  onChange: (type: string) => void
}

export default function PaymentMethodPicker({ methods, value, onChange }: PaymentMethodPickerProps) {
  const { t } = useTranslation()

  if (!methods.length) return null

  return (
    <div>
      <div className="text-[13px] text-[#374151] mb-2">{t('tt.topup.paymentMethod')}</div>
      <Radio.Group type="button" value={value} onChange={onChange}>
        {methods.map((m) => (
          <Radio key={m.type} value={m.type}>
            {m.name || getMethodLabel(m.type, t)}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  )
}
